var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"message":_vm.error,"type":_vm.error !== null ? 'is-danger' : ''}},[_c('b-input',{attrs:{"value":_vm.location,"type":"text","lazy":""},on:{"input":_vm.inputLocation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }